import { render, staticRenderFns } from "./ROAChart.vue?vue&type=template&id=54fd959a&scoped=true&"
import script from "./ROAChart.vue?vue&type=script&lang=js&"
export * from "./ROAChart.vue?vue&type=script&lang=js&"
import style0 from "./ROAChart.vue?vue&type=style&index=0&id=54fd959a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd959a",
  null
  
)

export default component.exports